export default __webpack_public_path__ + "1542b8685f9e6e85b7f6fd83fbbcf8cd.png";